import React from 'react'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import SuperUserAccountNameUI from '../../../templates/SuperUserAccountNameUI.js'

const AllChatPageUI = ({ context, errorList, filteredList, onRefreshClick, searchFilter, onSearchFilterChange, checked, onShowUnread }) =>
  <SuperUserAccountNameUI context={context} className='pg_su_cht_r' topnav='chats'
    centered={!filteredList} accountUserList={filteredList}
    searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
    checked={checked} onShowUnread={onShowUnread}
  >
    {
      !errorList && !filteredList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      filteredList &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='Select an user to open chat'
      />
    }
  </SuperUserAccountNameUI>

export default AllChatPageUI
